<template>
  <table class="table-hover reports-table invoices-aging-report-table table">
    <tbody class="thead">
      <tr>
        <th
          v-if="tableIsTeam"
          class="stick-cell"
        >
          <template v-if="isClient">Client</template>
          <template v-else>Member</template>
        </th>
        <th>0 - 30 days</th>
        <th>31 - 60 days</th>
        <th>60+ days</th>
        <th>Total</th>
      </tr>
    </tbody>

    <tbody class="tbody">
      <tr
        v-for="(row, index) in reportData"
        :key="index"
      >
        <td v-if="tableIsTeam">
          <template v-if="isClient">{{ row.client_name }}</template>
          <template v-else>
            <ReportTableAvatar
              :user-id="row.user_id"
              :url="row.avatar_url"
            />
            <span class="user-name">{{ row.user_name }}</span>
          </template>
        </td>
        <td>{{ row.owed_0_30 | currency(organization.currency) }}</td>
        <td>{{ row.owed_31_60 | currency(organization.currency) }}</td>
        <td>{{ row.owed_61 | currency(organization.currency) }}</td>
        <td>{{ row.owed_total | currency(organization.currency) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'InvoicesAgingReportTable',
  components: {},
  props: {
    reportData: Array,
    isClient: Boolean,
  },
  computed: {
    ...mapGetters(['tableIsTeam']),
    ...mapState(['organization']),
    colCount() {
      return this.tableIsTeam ? 5 : 4;
    },
  },
};
</script>
